export enum ClientsPermissions {
	ChClientsRegistryAdmin = "ChClientsRegistryAdmin",
	ChClientsRegistry = "ChClientsRegistry",
	ChClientsGrouping = "ChClientsGrouping",
	ChAccessAllClients = "ChAccessAllClients",
	ChAccessAllBranchClients = "ChAccessAllBranchClients",
	ChAccessAllProducersClients = "ChAccessAllProducersClients",
	ChClientsRegistryAdministratorReadOnly = "ChClientsRegistryAdministratorReadOnly",
}
